<template>
  <div class="card snapshot">
    <div class="snapshot__header">
      <h4 class="title">
        {{ translate('snapshot.new_snapshot') }}
      </h4>
    </div>

    <div class="snapshot__content">
      <div class="add_block">
        <sis-select
          :options="opt_orders"
          :label="translate('snapshot.orders.question')"
          :placeholder="translate('snapshot.orders.question')"
          v-model="params.client_order_id"
          :multiple="false"
          :clearable="false"
        />
      </div>

      <div class="add_block">
        <div class="form-group">
          <label>{{ translate('device.desc') }}</label>
          <textarea
              v-model="params.description"
              rows="3"
              class="form-control border-input"
              :placeholder="translate('device.desc')"
          />
        </div>
      </div>
    </div>

    <div class="snapshot__button">
      <button
        class="btn btn-success btn-fill btn-wd"
        @click.prevent="save"
      >
        {{ translate('snapshot.to_add') }}
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "NewSnapshot",

  data () {
    return {
      order_list: [],
      params:{
        client_order_id: null,
        description: null
      }
    }
  },
  computed:{
    opt_orders(){
      let list = []
      for (let order of this.order_list) {
        list.push({id: order.id, label: order.name})
      }
      return list
    }
  },
  created () {
    this.get_order_list()
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save () {
      this.$emit('take', this.params)
    },
    get_order_list(){
      this.$http.v1.getOrdersList((response) => {
        this.order_list = response.data
      })
    }
  }
}

</script>

<style lang='scss' scoped>

  .snapshot{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
    &__content{
      padding: 10px;
      height: 200px;
      textarea{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        outline: none;
        &::-webkit-scrollbar {
          width: 10px;
        }
      }
    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
      .btn{
        margin: 0 5px;
      }
    }
  }
  @media (max-width:600px) {
    .snapshot{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
